export default function getImageURL(icon: string) {
    return `${process.env.PUBLIC_URL}/images/${icon}.png`;
}

export function getImageURLRemoveSpaces(icon: string) {
    return `${process.env.PUBLIC_URL}/images/${icon.replace(/\s/g, '')}.png`;
}